/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Frustrating_FocusInputs */

const en_onboarding_frustrating_focus = /** @type {(inputs: Onboarding_Frustrating_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Difficulty staying focused`)
};

const es_onboarding_frustrating_focus = /** @type {(inputs: Onboarding_Frustrating_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dificultad para mantener la concentración`)
};

/**
* | output |
* | --- |
* | "Difficulty staying focused" |
*
* @param {Onboarding_Frustrating_FocusInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_frustrating_focus = /** @type {((inputs?: Onboarding_Frustrating_FocusInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Frustrating_FocusInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_frustrating_focus(inputs)
	return en_onboarding_frustrating_focus(inputs)
});